import { specialTopics } from '@prolaera/library';
import './style.less';
import angular from 'angular';

export default function($stateParams, $location, $timeout, RegulatorClass) {
  'ngInject';

  const vm = this;
  vm.regulatorId = $stateParams.license;
  vm.regulatorCategory = $stateParams.category;

  vm.$onInit = init;

  vm.updateModel = () => {
    vm.ngModel = filter();
    vm.update({
      events: vm.ngModel,
      license: vm.regulatorId,
      category: vm.regulatorCategory
    });
  };

  function filter() {
    let result = angular.copy(vm.input);

    if (vm.regulatorId === 'ea_cpa') {
      return result.filter(data => data.irs_approval_number);
    } 

    if (
      vm.regulatorId &&
      vm.regulatorDict[vm.regulatorId] &&
      vm.regulatorDict[vm.regulatorId].cycle_limiter &&
      vm.regulatorDict[vm.regulatorId].cycle_limiter.sponsors
    ) {
      const sponsors = vm.regulatorDict[vm.regulatorId].cycle_limiter.sponsors;
      result = vm.input.filter(data => {
        if (!data.sponsor || typeof data.delivery_method === 'undefined') {
          return false;
        }
        if (!data.sponsors || !data.sponsors_types) {
          try {
            const { sponsors, sponsors_types } = data.sponsor;
            data.sponsors_types = sponsors_types;
            data.sponsors = sponsors;
          } catch (e) {
            return false;
          }
        }

        const sponsorTypes = Object.keys(data.sponsors_types || {}).filter(key => data.sponsors_types[key]);

        if (data.delivery_method in sponsors === false) return true;

        if (
          data.delivery_method in sponsors &&
          sponsors[data.delivery_method].filter(sponsor => {
            return sponsorTypes.includes(sponsor) || data.sponsors[sponsor];
          }).length
        ) {
          return true;
        }
      });
    }

    if (!vm.regulatorId || !vm.regulatorDict[vm.regulatorId]) return result;

    const allCategories = Object.keys(vm.regulatorDict[vm.regulatorId].cycle_template).reduce((arr, key) => {
      arr.push(key); // Add special category keys
      if (vm.regulatorDict[vm.regulatorId][key]) arr.push(...vm.regulatorDict[vm.regulatorId][key]);
      return arr;
    }, []);

    result = result.filter(data => {
      const hourCats = [];
      if (data.hours)
        data.hours.forEach(hour => {
          hourCats.push(hour.category_id);

          specialTopics.forEach(({ key, secondary_key }) => {
            if (key === 'yellowbook') key = 'proficiency';
            if (hour[key] || hour[secondary_key]) hourCats.push(...[key, secondary_key]);
          });
        });

      if (data.category_id) hourCats.push(data.category_id);
      if (data.hours && vm.regulatorCategory === 'proficiency' && data.hours.filter(hour => hour.yellowbook).length)
        return true;
      if (hourCats.filter(cat => allCategories.includes(cat)).length) return true;
    });

    // THIS IS FOR FILTERING BASED ON THE CATEGORY
    if (!vm.regulatorCategory || !vm.regulatorDict[vm.regulatorId][vm.regulatorCategory]) return result;

    const categories = vm.regulatorDict[vm.regulatorId][vm.regulatorCategory];

    const filtered = result.filter(data => {
      const hourCats = [];
      if (data.hours)
        data.hours.forEach(hour => {
          hourCats.push(hour.category_id);

          specialTopics.forEach(({ key, secondary_key }) => {
            if (key === 'yellowbook') key = 'proficiency';
            if (hour[key] || hour[secondary_key]) hourCats.push(...[key, secondary_key]);
          });
        });
      if (data.category_id) hourCats.push(data.category_id);
      if (data.hours && vm.regulatorCategory === 'proficiency' && data.hours.filter(hour => hour.yellowbook).length)
        return true;

      if (hourCats.filter(cat => categories.includes(cat) || cat === vm.regulatorCategory).length) return true;
    });
    return filtered;
  }

  function init() {
    RegulatorClass.loadRegulators().then(regulators => {
      vm.regulators = regulators.arrCurrent;
      vm.regulatorDict = regulators.objCurrent;
      vm.updateModel();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/licenseCategoryFilter/controller.js